import React from 'react';
import styled from 'styled-components';

interface WebGLUnavailableMessageProps {
    bordered?: boolean;
    fullScreen?: boolean;
}

const WebGLUnavailableMessage = ({
    bordered = true,
    fullScreen = false,
}: WebGLUnavailableMessageProps) => {
    return (
        <Preview3DContainer
            data-cy="webgl-unavailable-message"
            $bordered={bordered}
            $fullScreen={fullScreen}>
            <PlaceholderText>
                Your browser or computer can&#39;t display the 3D view because
                WebGL is not supported or enabled in your browser.
                <br />
                <br />
                Please update your browser or try a supported device.
            </PlaceholderText>
        </Preview3DContainer>
    );
};

// fullScreen stands in for the standalone preview's full-screen container,
// below its Powered By and Product Info overlays, with padding so the centred
// text clears them and the "View In 3D Room Planner" button.
const Preview3DContainer = styled.div<{
    $bordered: boolean;
    $fullScreen: boolean;
}>`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 35px;

    ${({$bordered}) =>
        $bordered &&
        `
        border-radius: 8px;
        border-width: 2px;
        border-style: solid;
        border-color: rgb(var(--primary_colour));
    `}

    ${({$fullScreen}) =>
        $fullScreen &&
        `
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        box-sizing: border-box;
        z-index: 9999;
        padding: 150px 35px 180px;
        background: #fff;

        & > h4 {
            max-width: 800px;
        }
    `}
`;

const PlaceholderText = styled.h4`
    font-weight: 600;
    text-align: center;
    color: #757575;
    font-size: 22px;
`;

export default WebGLUnavailableMessage;
